const { fetchWithRetry } = require('./utils'); // A utility function to parse cookies  

// Function to create a new invoice  
const createInvoice = async (invoiceData) => {
    try {
        const response = await fetchWithRetry('/api/invoices', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(invoiceData)
        });

        if (!response.ok) {
            throw new Error(`Error creating invoice: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error creating invoice:', error);
        throw error;
    }
};

// Function to get all invoices with contestants  
const getAllInvoicesWithContestants = async () => {
    try {
        const response = await fetchWithRetry('/api/invoices/getAll', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (!response.ok) {
            throw new Error(`Error fetching all invoices: ${response.status} ${response.statusText}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching all invoices:', error.message);
        throw error;
    }
};

// Function to get invoices by contestant  
const getInvoicesByContestant = async (contestantId, roundNumber) => {
    try {
        const body = { contestant: contestantId };
        if (roundNumber) {
            body.roundNumber = roundNumber;
        }

        const response = await fetchWithRetry('/api/invoices/get', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        });

        if (!response.ok) {
            throw new Error(`Error fetching invoices: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error fetching invoices:', error);
        throw error;
    }
};

// Function to update an invoice  
const updateInvoice = async (invoiceData) => {
    try {
        const response = await fetchWithRetry('/api/invoices/update', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(invoiceData)
        });

        if (!response.ok) {
            throw new Error(`Error updating invoice: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error updating invoice:', error);
        throw error;
    }
};

// Function to delete an invoice  
const deleteInvoice = async (invoiceId, contestantId) => {
    try {
        const response = await fetchWithRetry('/api/invoices/delete', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ id: invoiceId, contestant: contestantId })
        });

        if (!response.ok) {
            throw new Error(`Error deleting invoice: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error deleting invoice:', error);
        throw error;
    }
};

// Function to toggle invoice paid status  
const toggleInvoicePaidStatus = async (invoiceId, paid) => {
    try {
        const response = await fetchWithRetry('/api/invoices/paid', {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ invoiceId, paid })
        });

        if (!response.ok) {
            throw new Error('Failed to toggle invoice paid status');
        }

        return await response.json();
    } catch (error) {
        console.error('Error toggling invoice paid status:', error);
        throw new Error('Error toggling invoice paid status: ' + error.message);
    }
};

// Function to fetch invoice stats  
const fetchInvoices = async () => {
    try {
        const response = await fetchWithRetry('/api/invoices/stats', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (!response.ok) {
            throw new Error(`Error fetching invoice stats: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error fetching invoice stats:', error);
        throw error;
    }
};

const getInvoiceByIDNumber = async (idNumber) => {
    try {
        const response = await fetchWithRetry('/api/invoices/' + idNumber, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (!response.ok) {
            throw new Error(`Error fetching invoice stats: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error fetching invoice stats:', error);
        throw error;
    }
};

// Function to get all guardian invoices  
const getAllGuardianInvoices = async () => {
    try {
        const response = await fetchWithRetry('/api/invoices/getAllInvoices', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.status} ${response.statusText}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching invoices:', error.message);
        throw error;
    }
};

// Function to get invoice status  
const getInvoiceStatus = async () => {
    try {
        const response = await fetchWithRetry('/api/invoice-status', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (!response.ok) {
            throw new Error(`Error fetching invoice status: ${response.statusText}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching invoice status:', error);
        throw error;
    }
};

// Function to remove pass from invoice  
const removePassFromInvoice = async (invoiceId, passId) => {
    try {
        const response = await fetchWithRetry('/api/invoices/removePass', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ invoiceId, passId })
        });

        if (!response.ok) {
            throw new Error(`Error removing pass from invoice: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error removing pass from invoice:', error);
        throw error;
    }
};

// Function to get all passes from an invoice  
const getAllPassesFromInvoice = async (invoiceId) => {
    try {
        const response = await fetchWithRetry(`/api/invoices/${invoiceId}/passes`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (!response.ok) {
            throw new Error(`Error fetching passes from invoice: ${response.statusText}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching passes from invoice:', error);
        throw error;
    }
};

// Function to add merchandise to an invoice  
const addMerchToInvoice = async (invoiceId, productId) => {
    try {
        const response = await fetchWithRetry('/api/invoices/addMerch', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ invoiceId, productId })
        });

        if (!response.ok) {
            throw new Error(`Error adding merchandise to invoice: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error adding merchandise to invoice:', error);
        throw error;
    }
};

// Function to remove merchandise from an invoice  
const removeMerchFromInvoice = async (invoiceId, productId) => {
    try {
        const response = await fetchWithRetry('/api/invoices/removeMerch', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ invoiceId, productId })
        });

        if (!response.ok) {
            throw new Error(`Error removing merchandise from invoice: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error removing merchandise from invoice:', error);
        throw error;
    }
};

const markGroupMembersInvoicesPaid = async (memberIdNumbers) => {
  try {
    const response = await fetchWithRetry("/api/invoices/paid/group-members", {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ memberIdNumbers, paid: true }),
    });

    if (!response.ok) {
      throw new Error("Failed to mark group member invoices as paid");
    }

    return await response.json();
  } catch (error) {
    console.error("Error marking group member invoices as paid:", error);
    throw new Error("Error marking group member invoices as paid: " + error.message);
  }
};

module.exports = {
    createInvoice,
    getInvoicesByContestant,
    updateInvoice,
    deleteInvoice,
    toggleInvoicePaidStatus,
    fetchInvoices,
    getAllGuardianInvoices,
    getAllInvoicesWithContestants,
    getInvoiceStatus,
    removePassFromInvoice,
    getAllPassesFromInvoice,
    addMerchToInvoice,
    removeMerchFromInvoice,
    getInvoiceByIDNumber,
    markGroupMembersInvoicesPaid
};  